import { UsuarioResponse, Filial } from "@apiUser";

/* =======================================================================
 * TIPOS GERAIS PARA AUTENTICAÇÃO E ACESSO
 * ======================================================================= */

/** Parâmetros de autenticação para a API. */
export interface AuthParams {
  username: string;
  password: string;
}

/** Chaves de query para os dados do usuário. */
export const usuarioKeys = {
  root: ["usuario"] as const,
  detail: (login: string) => [...usuarioKeys.root, login] as const,
};

/** Resposta esperada da API de autenticação. */
export interface AuthResponse {
  access_token: string;
  refresh_token: string;
  scope: string;
  token_type: string;
  expires_in: number;
  hasMFA: boolean;
}
export interface AuthData {
  tenantId: string;
  token: string;
  refreshToken: string;
  expiresAt: Date;
}
export type LoginParams = { username: string; password: string };
export type LoginResult = {
  tenantId: string;
  authData: AuthResponse;
  acessoData: UsuarioResponse;
};

export interface ExplodedGroupData {
  filiais: Filial[];
  empresas: string[];
  gruposApi: Array<{
    codigo: string;
    descricao: string;
  }>;
}
export interface PageAccess {
  isAdmin: boolean;
  isContab: boolean;
  isCompras: boolean;
  isBorracharia: boolean;
  isPortaria: boolean;
}
export const permissionMap: Record<keyof PageAccess, string[]> = {
  isAdmin: ["000000"],
  isBorracharia: ["000190"],
  isPortaria: ["000191"],
  isCompras: ["000013", "000014"],
  isContab: ["000115", "000077", "000128", "000131", "000135", "000193"],
};
